module.exports = __webpack_public_path__ + "static/media/ic-plus.9fd7ca8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sources/ic-plus.svg
// module id = 1430
// module chunks = 0